import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import { BidStatus } from '../../services';

export interface IAuctionBidStatusRenderer extends ICellRendererParams {}

export const showBidStatusColor = (bidStatus: string) => {
  switch (bidStatus) {
    case BidStatus.Closing:
      return '#33B1C3';
    case BidStatus.Draft:
      return 'yellow';
    case BidStatus.Accepted:
      return '#7DBC55';
    case BidStatus.Amended:
      return '#EF9F37';
    case BidStatus.Rejected:
      return '#EB777A';
    case BidStatus.Closed:
      return '#A275A2';
    default:
      return '';
  }
};

const AuctionBidStatusRenderer: React.FC<IAuctionBidStatusRenderer> = (
  props
) => {
  const propertyValue = props.data.bidStatus;

  return <span style={{ color: showBidStatusColor(propertyValue) }}>{propertyValue}</span>;
};
export default AuctionBidStatusRenderer;
